import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

const NoteModal = props => {
  const { isOpen, toggle, note, titleNote } = props;

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ minWidth: "40%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>{titleNote}</Label>
        </ModalHeader>
        <React.Fragment>
          <ModalBody>
            <Row className="font-size-14 text-danger mt-1">
              <Col>{note}</Col>
            </Row>
          </ModalBody>
        </React.Fragment>
      </div>
    </Modal>
  );
};

NoteModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  t: PropTypes.any,
  note: PropTypes.any,
  titleNote: PropTypes.any,
};

export default NoteModal;
